var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Connect-wallet",
    transform: "translate(-27.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "subdao-2",
    transform: "translate(27.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    fill: "#D51172",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 14
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.4581887,16.790128 C17.4581887,16.790128 19.8894988,12.0035397 21.1316773,10.2498422 C22.4998417,8.31465231 25.0681893,5.31018802 25.5699233,5.46325389 C26.1733303,5.64693293 25.4991943,9.09966153 25.4991943,12.3490312 C25.4991943,14.0021426 26.1755405,18.3382799 26.1755405,18.3382799 C26.1755405,18.3382799 31.0381607,18.0540147 34.1944433,18.7121979 C36.8290993,19.2588617 40.5423729,20.6298946 40.5423729,21.2880778 C40.5423729,21.946261 38.3453527,22.1408733 37.3573567,22.460125 C36.3693607,22.7793766 32.4527411,23.9907836 29.1107949,26.3523713 C29.1107949,26.3523713 31.7034556,30.1746446 32.5654655,34.9371797 C33.4274755,39.6997148 32.8528022,41.2784799 32.8528022,41.2784799 C32.8528022,41.2784799 32.687031,41.512452 32.1631942,40.8958152 C32.1631942,40.8958152 31.2216141,39.1989708 26.931457,36.0414406 C22.6412998,32.8839105 21.0079015,31.8627425 21.0079015,31.8627425 C19.5015724,32.6910768 18.0561484,33.6234456 16.6823798,34.6529145 C14.7771168,36.1289068 11.2053012,39.9686734 10.9842731,40.1895256 C10.7632449,40.4103777 10.4162306,40.5787502 10.3985484,40.0364597 C10.3808661,39.4941692 10.5201139,34.821287 11.2406658,32.0704747 C11.9612177,29.3196624 13.4509477,25.9740799 13.4509477,25.9740799 C12.3320331,24.5635517 11.0805817,23.261048 9.71336097,22.0840203 C7.65337824,20.3696826 4.76011923,18.051828 4.6783388,17.0241001 C4.63634345,16.4839962 8.15069167,16.2084777 11.4815865,16.3025039 C13.4809436,16.3631568 15.4758007,16.5259149 17.4581887,16.790128 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#D51172",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5423729,21.2455005 C40.5423729,21.2455005 34.6149133,20.6785487 30.4554488,21.4798127 C26.2959843,22.2810768 21.3081897,24.4484647 17.2801001,25.0886391 L13.2542373,25.7288136",
    id: "\\u8DEF\\u5F84",
    stroke: "#D51172",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5084746,5.45762712 C26.5084746,5.45762712 23.232588,11.0341591 22.7040782,16.4511082 C22.1755685,21.8680574 21.8305085,31.9661017 21.8305085,31.9661017",
    id: "\\u8DEF\\u5F84",
    stroke: "#D51172",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5084746,17.9322034 C26.5084746,17.9322034 22.4496024,23.5371041 19.7547231,25.7611287 C17.0598438,27.9851533 14.7313445,31.1978824 13.1444336,34.6886146 C12.2617785,36.5820117 11.5167286,38.5384906 10.9152542,40.5423729",
    id: "\\u8DEF\\u5F84",
    stroke: "#D51172",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9322034,17.1525424 C17.9322034,17.1525424 20.7374159,23.4533115 23.1508389,26.7180594 C25.564262,29.9828072 32.4149805,36.3073121 33.5254237,41.3220339",
    id: "\\u8DEF\\u5F84",
    stroke: "#D51172",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6271186,26.5084746 C29.6271186,26.5084746 21.8672557,24.8848807 19.8731742,23.6797841 C17.8790928,22.4746874 6.5596195,17.1919819 5.45762712,17.1525424",
    id: "\\u8DEF\\u5F84",
    stroke: "#D51172",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8d4f3a384ea9c8017ee710c9723110d9.svg";
export { ForwardRef as ReactComponent };